exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1M-w3GzeAv_2CA-aQtZGZY{width:80px;text-align:center}._21Mltk_eDLmMxJRGyQ0EJX{display:inline}._2jNazZq1I6H74sUdSPt47D{display:none}._1M-w3GzeAv_2CA-aQtZGZY:hover ._2jNazZq1I6H74sUdSPt47D{display:inline}._1M-w3GzeAv_2CA-aQtZGZY:hover ._21Mltk_eDLmMxJRGyQ0EJX{display:none}\n", ""]);

// Exports
exports.locals = {
	"FollowButton": "_1M-w3GzeAv_2CA-aQtZGZY",
	"normal": "_21Mltk_eDLmMxJRGyQ0EJX",
	"hover": "_2jNazZq1I6H74sUdSPt47D"
};